(() => {
  if (customElements.get('raitooe-navigation')) return;
  class RaitooeNavigation extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.groups = [...this.querySelectorAll('.rn-group')];
      this.drawer = this.querySelector('.rn-drawer');
      this.groups.forEach(group => {
        const content = group.querySelector('.rn-content');
        const links = [...content.children].filter(el => el.classList.contains('rn-link'));
        const cards = [...content.children].filter(el => el.classList.contains('rn-product'));
        group.style.setProperty('--rn-link-rows', Math.max(links.length, 1));
        group.style.setProperty('--rn-card-count', cards.length);
        if (group.dataset.layout === 'list' && this.dataset.mode === 'desktop') cards.forEach((card, index) => card.style.gridColumn = index + 2);
        if (this.dataset.mode === 'desktop') {
          group.querySelector('.rn-group-trigger').addEventListener('click', e => {
            const mouseClick = e.pointerType === 'mouse' || (!e.pointerType && e.detail > 0 && matchMedia('(hover: hover) and (pointer: fine)').matches);
            if (!mouseClick) return;
            e.preventDefault();
            clearTimeout(this.openTimer);
            clearTimeout(this.closeTimer);
            this.openGroup(group);
          }, { signal });
          group.addEventListener('pointerenter', e => {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(this.closeTimer);
            this.openTimer = setTimeout(() => this.openGroup(group), 150);
          }, { signal });
          group.addEventListener('pointerleave', () => {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => { if (!group.querySelector(':focus-visible')) group.open = false; }, 220);
          }, { signal });
        }
      });
      this.addEventListener('toggle', e => {
        if (e.target.classList.contains('rn-group') && e.target.open) {
          this.position();
          this.groups.forEach(g => { if (g !== e.target) g.open = false; });
        }
        if (e.target === this.drawer) this.drawerChanged();
      }, { capture: true, signal });
      this.addEventListener('click', e => {
        if (e.target.closest('[data-nav-close]') || e.target === this.drawer) this.closeDrawer();
      }, { signal });
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) this.closeAll(); }, { signal });
      this.addEventListener('keydown', e => this.keydown(e), { signal });
      window.addEventListener('resize', () => { this.closeAll(); this.position(); }, { signal });
      window.addEventListener('scroll', () => this.position(), { passive: true, signal });
      document.addEventListener('shopify:block:select', e => {
        const target = [...this.querySelectorAll('[data-shopify-editor-block]')].find(el => {
          try { return JSON.parse(el.dataset.shopifyEditorBlock).id === e.detail.blockId; } catch { return false; }
        });
        const group = target?.closest('.rn-group');
        if (group && this.dataset.mode === 'desktop') this.openGroup(group);
      }, { signal });
      this.position();
    }
    position() {
      const header = this.closest('header-component');
      if (header) this.style.setProperty('--rn-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    }
    openGroup(group) { this.position(); this.groups.forEach(g => g.open = g === group); }
    closeAll() { clearTimeout(this.openTimer); clearTimeout(this.closeTimer); this.groups.forEach(g => g.open = false); this.closeDrawer(); }
    closeDrawer() { if (this.drawer?.open) { this.drawer.open = false; this.drawer.querySelector('summary').focus(); } }
    drawerChanged() {
      if (!this.drawer) return;
      if (this.drawer.open) {
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.querySelector('[data-nav-close]').focus();
      } else if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }
    keydown(e) {
      if (e.key === 'Escape') {
        const group = this.groups.find(g => g.open);
        this.closeAll();
        if (!this.drawer && group) group.querySelector('summary').focus();
        e.preventDefault();
      }
      if (e.key === 'Tab' && this.drawer?.open) {
        const visible = [...this.querySelector('.rn-drawer-panel').querySelectorAll('a[href],button,summary')].filter(el => el.getClientRects().length);
        const first = visible[0], last = visible.at(-1);
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    }
    disconnectedCallback() { this.closeAll(); this.drawerChanged?.(); this.controller?.abort(); }
  }
  customElements.define('raitooe-navigation', RaitooeNavigation);
})();
